import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-menuitem",
  role: "none"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "p-menuitem-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_Button, {
      class: "p-button-aux smallIconBtn",
      disabled: $props.disabled,
      onClick: $setup.toggleMenu,
      icon: "pi pi-ellipsis-v"
    }, null, 8 /* PROPS */, ["disabled"]), [
      [_vShow, $setup.Props.menuItems.find(item=>(!item.permission || item.permission=='') || (item.permission in $setup.Props.data && $setup.Props.data[item.permission]))]
    ]),
    _createVNode(_component_Menu, {
      ref: "menuToggle",
      model: $setup.Props.menuItems,
      popup: true
    }, {
      item: _withCtx(({item}) => [
        ((!item.permission || item.permission=='') || (item.permission in $setup.Props.data && $setup.Props.data[item.permission]))
          ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
              _createElementVNode("a", {
                class: "p-menuitem-link",
                role: "menuitem",
                onClick: ($event: any) => (item.callback($setup.Props.data))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["p-menuitem-icon", item.icon])
                }, null, 2 /* CLASS */),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                  class: "p-ink",
                  role: "presentation"
                }, null, -1 /* CACHED */))
              ], 8 /* PROPS */, _hoisted_2)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model"])
  ], 64 /* STABLE_FRAGMENT */))
}